import { config } from "../../config";
import { Popover } from "react-tiny-popover";

import "./style.css";
import { useState } from "react";

export const Header = ({
  simulators,
  selectedSimulator,
  handleSetSimulator
}) => {
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);

  const popoverContent = (
    <div className="simulators-list">
      {simulators?.map(simulator => (
        <div
          className={`simulator-option ${
            simulator?.id === selectedSimulator?.id
              ? "selected-simulator-option"
              : ""
          }`}
          key={simulator.id}
          onClick={() => handleSetSimulator(simulator)}
        >
          {simulator.label}
        </div>
      ))}
    </div>
  );
  return (
    <div className="header">
      <div className="header-logo">{config.header.logo}</div>
      <Popover
        isOpen={isPopoverOpen}
        positions={["bottom", "top", "left", "right"]} // preferred positions by priority
        content={popoverContent}
        onClickOutside={() => setIsPopoverOpen(false)}
      >
        <button
          onClick={() => setIsPopoverOpen(!isPopoverOpen)}
          className="header-menu"
        >
          {config.header.menu}
        </button>
      </Popover>
    </div>
  );
};
